import { ProIcon } from './ProIcon';

interface Props {
  height?: number;
}

export const ProBadge = ({ height = 25 }: Props) => (
  <ProIcon width={40} height={height} />
);
